'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup from "./presto.types$-Compact-Group.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CompactGroup$() {
}
export { $c_Lpresto_types$CompactGroup$ as $c_Lpresto_types$CompactGroup$ };
$p = $c_Lpresto_types$CompactGroup$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CompactGroup$;
/** @constructor */
function $h_Lpresto_types$CompactGroup$() {
}
export { $h_Lpresto_types$CompactGroup$ as $h_Lpresto_types$CompactGroup$ };
$h_Lpresto_types$CompactGroup$.prototype = $p;
$p.l = (function() {
  return "CompactGroup";
});
$p.adF = (function(x$0) {
  return new $j_presto$002etypes$0024$002dCompact$002dGroup.$c_Lpresto_types$CompactGroup(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$CompactGroup$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CompactGroup$, "presto.types$CompactGroup$", ({
  YS: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$CompactGroup$ as $d_Lpresto_types$CompactGroup$ };
var $n_Lpresto_types$CompactGroup$;
function $m_Lpresto_types$CompactGroup$() {
  if ((!$n_Lpresto_types$CompactGroup$)) {
    $n_Lpresto_types$CompactGroup$ = new $c_Lpresto_types$CompactGroup$();
  }
  return $n_Lpresto_types$CompactGroup$;
}
export { $m_Lpresto_types$CompactGroup$ as $m_Lpresto_types$CompactGroup$ };
//# sourceMappingURL=presto.types$-Compact-Group$.js.map
